import makeSlice from '@web/slices/payLater/sliceMaker'

const slice = makeSlice()

export default slice.reducer
